import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatButtonModule, MatIconModule, MatToolbarModule } from '@angular/material';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { LeadQueuePannelComponent } from './lead-queue-pannel.component';

@NgModule({
  imports: [
    RouterModule,
    TranslateModule,

    MatButtonModule,
    MatIconModule,
    MatToolbarModule,
    MatProgressBarModule,

    FuseSharedModule
  ],
  declarations: [LeadQueuePannelComponent],
  exports: [LeadQueuePannelComponent]
})
export class LeadQueuePannelModule { }



// WEBPACK FOOTER //
// ./src/app/main/lead-queue-pannel/lead-queue-pannel.module.ts